<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: `商业/雇主名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerNameCN`,
					props: {
						suggest: {
							typeIncludes: `employerNameCN`
						},
						createOptions: {
							type: `employerNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `业务性质`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerNatureOfBusinessCN`,
					props: {
						suggest: {
							typeIncludes: `employerNatureOfBusinessCN`
						},
						createOptions: {
							type: `employerNatureOfBusinessCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "公司地址",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0employerAddressCN",
					props: {
						suggest: {
							typeIncludes: "employerAddressCN"
						},
						createOptions: {
							type: "employerAddressCN"
						}
					}
				},
				{
					label: `职业及职务`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupationPositionCN`,
					props: {
						suggest: {
							typeIncludes: `occupationPositionCN`
						},
						createOptions: {
							type: `occupationPositionCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `职责`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupationDutiesCN`,
					props: {
						suggest: {
							typeIncludes: `occupationDutiesCN`
						},
						createOptions: {
							type: `occupationDutiesCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `公司网址`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerWebsiteURLCN`,
					props: {
						suggest: {
							typeIncludes: `employerWebsiteURLCN`
						},
						createOptions: {
							type: `employerWebsiteURLCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `商业电话号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerTelephoneNoCN`,
					props: {
						suggest: {
							typeIncludes: `employerTelephoneNoCN`
						},
						createOptions: {
							type: `employerTelephoneNoCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `商业传真号码`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerFaxNoCN`,
					props: {
						suggest: {
							typeIncludes: `employerFaxNoCN`
						},
						createOptions: {
							type: `employerFaxNoCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
